<template>
  <div class="tool-btns">
    <a href="#story" class="to-top-btn" :class="{'hidden': !showTopBtn}" v-smooth-scroll>
      <div>
        <i class="fas fa-caret-up"></i>
        <small>Top</small>
      </div>
    </a>

    <a href="#" class="to-bottom-btn" :class="{'hidden': !showBottomBtn}" @click.prevent="__toBottomBtnClicked">
      <div>
        <small>{{question?'問':'末'}}</small>
        <i class="fas fa-caret-down"></i>
      </div>
    </a>
  </div>
</template>


<script>
import $ from "jquery";

export default {
  name: 'top-bottom-button',
  props: {
    question: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showTopBtn: false,
      showBottomBtn: false,
    };
  },
  mounted() {
    document.addEventListener('scroll', this.__scrollingEvent, false);
  },
  methods: {
    __scrollingEvent() {
      const winH = window.innerHeight;
      const docH = this.__getDocumentHeight();
      const nowS = window.scrollY;

      if(nowS >= winH){
        this.showTopBtn = true;
        if(nowS >= (docH - winH - 200)){
          this.showBottomBtn = false;
        }else{
          this.showBottomBtn = true;
        }
      }else{
        this.showTopBtn = false;
        this.showBottomBtn = false;
      }
    },
    __getDocumentHeight() {
      let body = document.body;
      let html = document.documentElement;

      let height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
      return height;
    },
    __toBottomBtnClicked() {
      const winH = window.innerHeight;
      const docH = $(document).height();

      $('html, body').animate({
        scrollTop: docH-winH
      }, 500);
    }
  }
}
</script>

<style scoped>

.tool-btns a{
  color: #fff;
  transition: transform .4s ease;
}

.tool-btns a:hover, .tool-btns a:focus{
  text-decoration: none;
}

.tool-btns a.hidden{
  transform: translate(100px, 0);
}

.tool-btns a{
  color: #fff;
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: solid 3px #ddd;
  position: fixed;
  background-color: #000;
}

a.to-top-btn{
  top: 10px;
  right: 10px;
}

a.to-bottom-btn{
  bottom: 10px;
  right: 10px;
}

a.to-top-btn>div, a.to-bottom-btn>div{
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

a.to-top-btn small, a.to-bottom-btn small{
  margin: 0;
}


</style>
